import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_explorer = _resolveComponent("project-explorer")

  return ($options.hasTags)
    ? (_openBlock(), _createBlock(_component_project_explorer, {
        key: 0,
        tags: $options.projectExplorerTags,
        source: $options.source,
        "default-tag-key": $options.defaultTagKey
      }, null, 8 /* PROPS */, ["tags", "source", "default-tag-key"]))
    : _createCommentVNode("v-if", true)
}